// @flow
import cookieUtils from '../../utils/cookieUtils';
import type {Store} from '../../reducers/index';
import {LOCATION_COOKIE} from '../../utils/locationData';

/* TODO: remove this cookie when we consolidate. See SERP-837 */
export default function locationDidChange(
    store: Store,
    action: {type: string, payload: Object}
) {
    if (action.payload.params.q) {
        /* read the ha-state-prst cookie */
        const haStatePersistCookie = cookieUtils.readCookie(LOCATION_COOKIE);
        /* add / override the lbsKeywords */
        haStatePersistCookie.lbsKeywords = action.payload.params.q;
        /* write the new ha-state-prst cookie for PDP / Homepage */
        cookieUtils.writeCookie(LOCATION_COOKIE, haStatePersistCookie);
    }
}
